<template>
  <div
    :class="[`r-title ${type} ${colorType}`, {center}]"
    :style="getStyle()"
  >
    <slot />
  </div>
</template>

<script>
const titleTypes = ['title-1', 'title-2', 'title-3', 'subtitle-1', 'subtitle-2']

export default {
  props: {
    type: {
      validator: value => titleTypes.indexOf(value) !== -1,
      default: 'title-1'
    },
    color: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: null
    },
    center: {
      type: Boolean,
      default: false
    },
    colorType: {
      type: String,
      default: ''
    },
    weight: {
      type: Number,
      default: null
    },
    textAlign: {
      type: String,
      default: null
    }
  },
  methods: {
    getStyle() {
      const styles = {}

      if (this.size) styles['font-size'] = `${this.size}px`

      if (this.color) styles.color = `${this.color} !important`

      if (this.weight) styles['font-weight'] = `${this.weight} !important`

      if (this.textAlign) styles['text-align'] = this.textAlign

      return styles
    }
  }
}
</script>

<style lang="scss" scoped>
.r-title {
  color: var(--text_primary);
  display: flex;
  align-items: center;

  &.center {
    text-align: center;
    justify-content: center;
  }

  &.title-1 {
    font-weight: 600;
    line-height: 24px;
    font-size: 18px;
  }

  &.title-2 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
  }

  &.title-3 {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }

  &.subtitle-1 {
    font-weight: 600;
    line-height: 20px;
    font-size: 14px;
  }

  &.subtitle-2 {
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  &.subhead {
    color: var(--text_subhead) !important;
  }

  &.secondary {
    color: var(--text_secondary) !important;
  }

  &.primary {
    color: var(--text_primary) !important;
  }

  &.accent-primary {
    color: var(--accent_primary) !important;
  }

  &.error {
    color: var(--accent_error) !important;
  }
}
</style>
